$(() => {
  $('.agenda-day .event').Accordion({
    toggleContainer: '.description',
    toggleButton: '.accordion-toggle',
    toggleClass: 'active',
  })
})
